import apiClient from './client'
import { plannerApiUrl } from '@/config/api'
import {
  PointChargeReqDto,
  PointChargeResDto,
  PurchaseProReqDto,
  PurchaseProResDto,
  PointBalanceResDto,
  AdminPointChargeReqDto,
  AdminPointChargeResDto,
} from '@/store/types/point.types'

/**
 * Dreamity Point API
 * 포인트 관련 API
 */
export const pointApi = {
  /**
   * 1. 포인트 충전
   * POST /api/dreamity/point/charge
   * 인앱 결제 토큰을 검증하여 포인트를 충전합니다.
   */
  chargePoint: async (data: PointChargeReqDto): Promise<PointChargeResDto> => {
    const response = await apiClient.post(plannerApiUrl('point/charge'), data)
    return response.data
  },

  /**
   * 2. PRO 구독 구매
   * POST /api/dreamity/point/purchase-pro
   * 포인트를 소모하여 PRO 등급 기간을 연장합니다. productType: HOUR(5P), DAY(50P), MONTH(500P)
   */
  purchasePro: async (data: PurchaseProReqDto): Promise<PurchaseProResDto> => {
    const response = await apiClient.post(plannerApiUrl('point/purchase-pro'), data)
    return response.data
  },

  /**
   * 3. 포인트 잔액 조회
   * GET /api/dreamity/point/balance
   * 현재 포인트 잔액을 조회합니다.
   */
  getBalance: async (): Promise<PointBalanceResDto> => {
    const response = await apiClient.get(plannerApiUrl('point/balance'))
    return response.data
  },

  /**
   * 4. 관리자용 포인트 충전
   * POST /api/dreamity/point/admin/charge
   * 관리자가 특정 사용자에게 포인트를 직접 부여합니다.
   */
  adminChargePoint: async (data: AdminPointChargeReqDto): Promise<AdminPointChargeResDto> => {
    const response = await apiClient.post(plannerApiUrl('point/admin/charge'), data)
    return response.data
  },
}

